import React from 'react';

export default function SearchEmptyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '120'}
      height={props.height ?? '120'}
      {...props}
    >
      <rect width="120" height="120" rx="60" fill="#F7F7F7" />
      <path
        d="M76.1467 53.5891C76.1467 57.0764 75.1126 60.4853 73.1751 63.3849C71.2377 66.2845 68.4839 68.5444 65.262 69.879C62.0402 71.2135 58.4949 71.5627 55.0746 70.8823C51.6543 70.202 48.5126 68.5227 46.0467 66.0568C43.5808 63.5909 41.9015 60.4492 41.2211 57.0289C40.5408 53.6086 40.89 50.0634 42.2245 46.8416C43.559 43.6198 45.819 40.866 48.7186 38.9286C51.6182 36.9911 55.0272 35.957 58.5145 35.957C63.1908 35.957 67.6757 37.8147 70.9823 41.1213C74.289 44.428 76.1467 48.9128 76.1467 53.5891Z"
        stroke={props.stroke ?? '#909090'}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M86.744 81.8225L70.9661 66.0447"
        stroke={props.stroke ?? '#909090'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.4258 84.957H33.5"
        stroke={props.stroke ?? '#909090'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.4255 78.8049L40.8823 78.8049"
        stroke={props.stroke ?? '#909090'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
